import { apiService } from './apiService';
import { Subject } from '../types/api.types';

export const subjectService = {
  async getSubjects(): Promise<Subject[]> {
    const response = await apiService.request<Subject[]>({
      url: '/subjects',
      method: 'GET'
    });
    return response.data;
  },

  async getAvailableSubjects(): Promise<Subject[]> {
    // Add cache-busting to ensure fresh data
    const response = await apiService.request<Subject[]>({
      url: `/subjects/available?_t=${Date.now()}`,
      method: 'GET'
    });
    return response.data;
  },

  async archiveSubject(subjectId: string) {
    const response = await apiService.request({
      url: `/subjects/${subjectId}/archive`,
      method: 'POST'
    });
    return response.data;
  },

  async subscribeToSubject(subjectId: string) {
    const response = await apiService.request({
      url: `/subjects/${subjectId}/subscribe`,
      method: 'POST'
    });
    return response.data;
  },

  async unsubscribeFromSubject(subjectId: string) {
    const response = await apiService.request({
      url: `/subjects/${subjectId}/unsubscribe`,
      method: 'POST'
    });
    return response.data;
  }
};
